module.exports = __webpack_public_path__ + "static/media/edit_top_navbar_icon.e9531c4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit_top_navbar_icon.svg
// module id = 442
// module chunks = 1